/**
 * UpsellNotice — locked-rung upsell card for tier-gated features.
 *
 * Shown in place of a feature's content when the org's tier does not include it
 * (Audience → Pro, Похожие источники → Team). Plan management lives in the bot,
 * so the CTA deep-links there. On-brand: SENSOR design tokens, no em-dash.
 */
const BOT_URL = 'https://t.me/sensor_tg_bot'

export function UpsellNotice({
  title,
  description,
  tier,
}: {
  title: string
  description: string
  tier: string
}) {
  return (
    <div
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--line)',
        borderRadius: 'var(--r-lg)',
        padding: '44px 28px',
        display: 'grid',
        justifyItems: 'center',
        textAlign: 'center',
        gap: 14,
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          background: 'var(--accent-soft)',
          color: 'var(--accent-ink)',
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
          <rect x="5" y="11" width="14" height="9" rx="2" />
          <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
      </div>
      <h2 style={{ fontSize: 18, fontWeight: 600, letterSpacing: '-0.01em', margin: 0, color: 'var(--ink)' }}>
        {title}
      </h2>
      <p style={{ fontSize: 14, color: 'var(--ink-3)', margin: 0, maxWidth: '46ch', lineHeight: 1.5 }}>
        {description}
      </p>
      <a
        className="btn btn--primary btn--sm"
        href={BOT_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ marginTop: 4, textDecoration: 'none' }}
      >
        Открыть на {tier}
      </a>
    </div>
  )
}
